import { useEnvironment } from '#cutils/context/EnvironmentContext';

import { useFetch } from './useFetchState';

type UseLocationInput = {
	searchTerm: string | null;
	shouldFetch?: boolean;
	limit?: number;
};

export type WeatherLocation = {
	city: string;
	height: number;
	label: string;
	plz: string;
	value: string;
};

type LocationAPIResponse = {
	items: WeatherLocation[];
};

export function useLocationAPI({ searchTerm, shouldFetch = true, limit = 5 }: UseLocationInput) {
	const { endpoints } = useEnvironment();

	const { isLoading, hasError, data } = useFetch<LocationAPIResponse>(
		searchTerm ? `${endpoints.ENDPOINT_REST_API}/location/${searchTerm}` : null,
		shouldFetch && (searchTerm?.length ?? 0) > 1
	);

	return {
		hasError: hasError || (data !== null && !data.items),
		isLoading,
		locationSuggestions: data?.items?.slice(0, limit) ?? [],
	};
}
